import { render, staticRenderFns } from "./CompanyBadge.vue?vue&type=template&id=ba75fa6a&scoped=true&"
import script from "./CompanyBadge.vue?vue&type=script&lang=js&"
export * from "./CompanyBadge.vue?vue&type=script&lang=js&"
import style0 from "./CompanyBadge.vue?vue&type=style&index=0&id=ba75fa6a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba75fa6a",
  null
  
)

export default component.exports